import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import _ from 'lodash';
import { I18NConsumer } from 'commons';
import 'react-datepicker/dist/react-datepicker.css';

class DatePickerSection extends React.PureComponent {
  constructor(props) {
    super(props);
    const { selectDate } = this.props;
    this.state = {
      selectDate: selectDate ? moment(selectDate) : undefined,
    };
    this.changeDate = value => {
      const { selectDate: curSelectDate = moment().startOf('day') } = this.state;
      const hour = curSelectDate.hour();
      const min = curSelectDate.minute();

      this.setState({
        selectDate: moment(
          value.hour(hour).minute(min),
        ),
      });
    };
    this.changeHour = event => {
      const { value } = event.target;
      const { selectDate: curSelectDate = moment().startOf('day') } = this.state;

      this.setState({
        selectDate: moment(curSelectDate.hour(value)),
      });
    };
  }

  componentWillReceiveProps(props) {
    const { selectDate } = props;
    const { selectDate: curSelectDate } = this.props;
    if (selectDate && selectDate !== curSelectDate) {
      this.initDatePicker(selectDate);
    }
  }

  changeMin = event => {
    const { value } = event.target;
    const { handleDateChange } = this.props;
    const { selectDate: curSelectDate = moment().startOf('day') } = this.state;

    this.setState(
      {
        selectDate: moment(curSelectDate.minute(value)),
      },
      () => {
        handleDateChange(this.getUTCDate());
        this.datePicker.setOpen(false);
      },
    );
  };

  getUTCDate = (value) => {
    const { dateformat } = this.props;
    const dateValue = !_.isNaN(moment(value).valueOf()) ? moment(value) : null;
    this.setState({
      selectDate: dateValue,
    });
    return dateValue ? moment(dateValue.valueOf()).format(dateformat) : '';
  }

  initDatePicker(initTime) {
    const formatInitTime = moment(initTime || undefined);

    this.setState({
      selectDate: formatInitTime,
    });
  }

  render() {
    const {
      handleDateChange, showTime, editable, dateformat, locale, invalid, attrId, ariaRequired, ariaDescribedby, ...props
    } = this.props;
    const { selectDate } = this.state;
    const hour = selectDate ? selectDate.format('H') : 0;
    const minute = selectDate ? selectDate.format('m') : 0;
    const hoursOptions = new Array(24).fill(0);
    const minOptions = new Array(60).fill(0);
    return (
      <I18NConsumer>
        {(i18n) => (
          <DatePicker
            disabled={!editable}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            todayButton={i18n['ssp.addition.information.datepicker.today.button']}
            placeholderText={i18n['ssp.addition.information.datepicker.tip']}
            className="form-control"
            selected={selectDate}
            popperContainer={({ children }) => (<div aria-hidden="true">{children}</div>)}
            onChange={value => {
              if (showTime) {
                this.changeDate(value);
              } else {
                handleDateChange(this.getUTCDate(value));
              }
            }}
            ref={
              ref => {
                this.datePicker = ref;
              }
            }
            locale={locale}
            dateFormat={dateformat}
            shouldCloseOnSelect={!showTime
            }
            customInput={
              <input
                aria-invalid={invalid}
                aria-labelledby={`${attrId}Label`}
                aria-describedby={ariaDescribedby? ariaDescribedby :`${attrId}Label`}
                aria-required={!!ariaRequired}
                role="textbox"
                name={attrId}
              />}
            {...props}
          >
            {
              showTime && (
                <div className="">
                  <div className="mb-1">
                    <label className="col-4" htmlFor="datePickerHours">Hours:</label>
                    <select className="col-6" value={hour || 0} onChange={this.changeHour}>
                      {hoursOptions.map((item, index) => (
                        <option key={`hourInput${index}`} value={index}>
                          {index}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="col-4" htmlFor="datePickerMinutes">Minutes:</label>
                    <select className="col-6" value={minute || 0} onChange={this.changeMin}>
                      {minOptions.map((item, index) => (
                        <option key={`minInput${index}`} value={index}>
                          {index}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )
            }
          </DatePicker>
        )}
      </I18NConsumer>
    );
  }
}

DatePickerSection.propTypes = {
  invalid: PropTypes.bool,
  showTime: PropTypes.bool,
  selectDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  handleDateChange: PropTypes.func,
  editable: PropTypes.bool,
  dateformat: PropTypes.string,
  locale: PropTypes.string,
  attrId: PropTypes.number.isRequired,
};
DatePickerSection.defaultProps = {
  showTime: false,
  selectDate: null,
  handleDateChange: () => { },
  editable: true,
  dateformat: 'YYYY-MM-DD',
  locale: 'en',
  invalid: false,
};

export default DatePickerSection;
